import React, { useCallback } from 'react';
import { Link } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getQueryFromUrl } from './helpers';
import { LinkWrapperStyled, SearchItemStyled } from './styled';
export function SearchContentItem({ page, isActive, handleClickLink }) {
    const onClickLink = useCallback(() => {
        handleClickLink(getQueryFromUrl(page.url));
    }, [handleClickLink, page]);
    return (React.createElement(SearchItemStyled, { isActive: isActive, onClick: onClickLink },
        React.createElement(LinkWrapperStyled, { to: page.url },
            React.createElement(SVGIcon, { type: Link }),
            React.createElement(RegularTextLevel4, null, page.title))));
}
